<template>
  <v-card class="mx-auto" :loading="loading || saving">
    <v-card-title class="grey darken-3">
      <!--<v-avatar size="80" rounded>
        <v-img src="https://cdn.vuetifyjs.com/images/profiles/marcus.jpg"></v-img>
      </v-avatar>-->

      <div class="text-h4 ml-4">{{user.first_name}} {{user.last_name}}</div>

      <v-spacer></v-spacer>

      <v-icon class="mr-4" color="success" title="Verified" v-if="user.isVerified">mdi-account-check-outline</v-icon>
      <v-icon class="mr-4" color="warning" title="Not yet verified" v-if="!user.isVerified">mdi-account-lock-outline</v-icon>
      <v-btn dark icon class="mr-4" @click="edit = !edit" v-if="!myCard && user.id">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>

      <v-menu bottom left v-if="!myCard && user.id">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="deleteUser()">
            <v-list-item-icon>
              <v-icon color="red">mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-title>

    <v-card-text v-if="edit || isNew">
      <v-form ref="form" v-model="valid" @submit.prevent="saveUser" lazy-validation>
        <v-card flat>
          <v-card-title>
            <span class="headline">
              User's
              <span class="pl-3 subtitle-1">Information</span>
            </span>
          </v-card-title>
          <v-card-text>
            <v-alert dense type="warning" v-if="errors.server">{{errors.server}}</v-alert>
            <v-container v-if="user">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="First Name*"
                    v-model="user.first_name"
                    :rules="nameRules"
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Last Name*"
                    v-model="user.last_name"
                    :rules="nameRules"
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Email*"
                    v-model="user.email"
                    :rules="emailRules"
                    :error-messages="errors.email"
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Cell" v-model="user.cell"></v-text-field>
                </v-col>
                <v-col cols="12" md="6" v-if="isNew || userRole">
                  <v-select
                    :items="roles"
                    v-model="userRole"
                    item-text="name"
                    label="User role"
                    return-object
                    persistent-hint
                    :hint="userRole && userRole.description"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color outlined @click="cancel()">Cancel</v-btn>
            <v-btn color="primary" outlined type="submit">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-card-text>

    <v-list two-line v-if="user && !edit && !isNew">
      <v-list-item>
        <v-list-item-icon>
          <v-icon color>mdi-phone</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{user.cell}}</v-list-item-title>
          <v-list-item-subtitle>Cell</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon>
          <v-icon>mdi-message-text</v-icon>
        </v-list-item-icon>
      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color>mdi-email</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{user.email}}</v-list-item-title>
          <v-list-item-subtitle>Email</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color>mdi-badge-account</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <div v-for="role in user.roles" :key="role.id">
            <v-chip
              class="mb-2"
              @click="roleDescription = !roleDescription ? role.description : ''"
            >{{role.name}}</v-chip>
          </div>
          <v-list-item-subtitle v-if="roleDescription">{{roleDescription}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    loading: false,
    edit: false,
    valid: true,
    saving: false,
    errors: {},
    roleDescription: "",
    nameRules: [
      v => !!v || "First and last name is required",
      v => (v && v.length >= 3) || "Cannot be less than 3 characters"
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ]
  }),
  created() {},
  mounted() {},
  computed: {
    ...mapGetters("apiAuth", { me: "user" }),
    myCard() {
      return this.me.id === this.user.id;
    },
    isNew() {
      return !this.user.id;
    },
    userRole: {
      get() {
        return (this.user.roles && this.user.roles.length) ? this.user.roles[0] : null;
      },
      set(role) {
        this.user.roles = [role];
      }
    }
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    validate() {
      return this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
      this.errors.server = "";
    },
    cancel() {
      this.edit = false;
      this.saved();
    },
    async deleteUser() {
      this.user.remove();
    },
    async saveUser() {
      if (!this.validate()) return;
      this.saving = true;

      try {
        let user = await this.user.save();
        this.saved(user);
        this.showMessage({
          text: `${user.first_name} saved!`,
          color: "success"
        });
        this.edit = false;
        this.saving = false;
      } catch (error) {
        this.saving = false;
        this.error = error;
        this.showMessage({
          text: error.message || "Error occured!",
          color: "red"
        });
      }
    }
  },
  watch: {},
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    },
    roles: {
      type: Array,
      default: () => {
        return [];
      }
    },
    saved: {
      type: Function,
      default: () => {
        return () => {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>